import CompanyRoleOptionsCreate from './create';
import CompanyRoleOptionsEdit from './edit';
import CompanyRoleOptionsList from './list';
import CompanyRoleOptionsIcon from '@material-ui/icons/PermIdentity';

const CompanyRoleOptionsTitle = ({record}) => {
    return record ? `${record.name}` : ''
}

export { CompanyRoleOptionsCreate, CompanyRoleOptionsEdit, CompanyRoleOptionsList, CompanyRoleOptionsTitle, CompanyRoleOptionsIcon };